import { Component, computed, Inject, signal } from '@angular/core';
import { form, FormField, min, required } from '@angular/forms/signals';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MceSaveCancelComponent } from '../../components/mce-save-cancel/mce-save-cancel.component';
import { MceSaveCancelEvent } from '../../components/mce-save-cancel/mce-save-cancel.component';
import { MceSaveCancelConfig } from '../../components/mce-save-cancel/mce-save-cancel.component';
import { MatInputModule } from '@angular/material/input';
import { buildPowerFactorSchema, PowerFactor } from '../../../cables/cables-edit/common/power-factor/power-factor.model';
import { PowerFactorComponent } from '../../../cables/cables-edit/common/power-factor/power-factor.component';

interface FormModel {
  i: number; // in kA
  pf: PowerFactor
}



@Component({
  selector: 'app-short-circuit-ka',
  imports: [FormField, MatDialogModule, MceSaveCancelComponent, MatInputModule, PowerFactorComponent],
  templateUrl: './short-circuit-ka.component.html',
  styles: ``,
})
export class ShortCircuitKaComponent {

  formModel = signal<FormModel>({
    i: 0,
    pf: {pf: 1, lagging: true} });

  form = form(this.formModel, (path) => {

    required(path.i, { message: `Fault current  is required` });
    min(path.i, 0.1, { message: `Fault current  must be above 0 m` });

    buildPowerFactorSchema(path.pf);

  });

  constructor(
    public dialogRef: MatDialogRef<ShortCircuitKaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {title: string, isDC:boolean }
  ) { }

  inputData = computed(() => this.data);

  readonly saveCancelConfig = computed<MceSaveCancelConfig>(() => ({
    save: { show: true, enable: this.form().valid() },
    cancel: { show: true, enable: true }
  }));


  onSaveClick(): void {
    console.log('onSaveClick:',this.form().value());
    this.dialogRef.close(this.form().value());
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onSaveCancelAction(event: MceSaveCancelEvent): void {
    if (event.type === 'save') {
      this.onSaveClick();
      return;
    }

    if (event.type === 'cancel') {
      this.onCancelClick();
    }
  }

}
